/**
 * Upcoming Convenings Swiper
 */
export default function () {
    const swiperEl = document.querySelector('.upcoming-convenings__swiper');

    if (!swiperEl) return;

    const forceTabindex = () => {
        swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
            slide.setAttribute('tabindex', '0');
        });
    };

    const observer = new MutationObserver(() => {
        swiperEl.querySelectorAll('.swiper-slide').forEach((el) => {
            if (el.getAttribute('tabindex') === '-1') {
                el.setAttribute('tabindex', '0');
            }
        });
    });

    observer.observe(swiperEl, {
        attributes: true,
        attributeFilter: ['tabindex'],
        subtree: true,
    });

    new Swiper(swiperEl, {
        slidesPerView: 1.07,
        spaceBetween: 20,
        breakpoints: {
            768: {
                spaceBetween: 24,
                slidesPerView: 'auto',
            },
        },
        navigation: {
            nextEl: '.upcoming-convenings__swiper__btn.next',
            prevEl: '.upcoming-convenings__swiper__btn.prev',
        },
        keyboard: {
            enabled: true,
        },
        on: {
            init: function () {
                forceTabindex();
                setSlideHeightsToMax(this);
            },
            resize: function () {
                setSlideHeightsToMax(this);
            }
        }
    });

    /**
     * Sets all slide heights to the tallest slide
     * @param {object} swiper - Swiper instance
     */
    function setSlideHeightsToMax(swiper) {
        const slides = swiper.slides;
        let maxHeight = 0;
        const paddingAddition = 48;

        slides.forEach((slide) => {
            const content = slide.querySelector('.upcoming-convenings__team-member');
            if (content) {
                content.style.height = '';
                const contentHeight = content.clientHeight + paddingAddition;
                maxHeight = Math.max(maxHeight, contentHeight);
            }
        });

        slides.forEach((slide) => {
            const content = slide.querySelector('.upcoming-convenings__team-member');
            if (content) {
                content.style.height = maxHeight + 'px';
            }
        });
    }
}
